import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Vant from 'vant';
import 'vant/lib/index.css';
import VueClipboard from 'vue-clipboard2'
import NavBar from '@/components/NavBar.vue';
import TabBar from '@/components/TabBar.vue';
import 'vant/lib/index.css';
Vue.component('NavBar', NavBar)
Vue.component('TabBar', TabBar)

Vue.use(Vant);
Vue.use(VueClipboard)

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router
}).$mount('#app')
